import React from 'react';

import { Hamburger } from '$partials/icons/index.js';
import { useNavigation } from '$contexts/navigation.jsx';
import Button from '$partials/ui/button.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const NavigationButton = () => {
    const {
        backgroundColour,
        isOpen,
        textColour,
        open,
    } = useNavigation();

    if (isOpen) { return null; }

    return (
        <>
            <style dangerouslySetInnerHTML={{
                __html: `
                    .primary-navigation__button {
                        --background: ${backgroundColour};
                        --foreground: ${textColour};
                    }
                `}} />

            <Button
                aria-label='Open primary navigation menu'
                className='primary-navigation__button'
                id='primary-navigation'
                onClick={() => open()}
                type='button'>
                <Hamburger />
            </Button>
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {};
NavigationButton.propTypes = propTypes;

export default NavigationButton;
